// extracted by mini-css-extract-plugin
module.exports = {"Column":"CBBFCColumn_Column__3m2Q0","ColumnWrapper":"CBBFCColumn_ColumnWrapper__28plq","Line":"CBBFCColumn_Line__BT-lP"};